
<script>
export default {
    name: "InputText",

    props: {
        callback: {
            type: String
        },
        value: {
            type: String
        }
    },

    methods: {
        valueChanged(event) {
            this.$emit("input", event.target.value);
        },
    }
}
</script>

<template>
    <input type="text" class="form-input" :value="value" @input="valueChanged"/>
</template>


